// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"3630ac43","380":"31d6cfe0","404":"5ff22d79"}[chunkId] + ".chunk.css";
};